import { render, staticRenderFns } from "./takeOrder.vue?vue&type=template&id=e13bf8a4"
import script from "./takeOrder.vue?vue&type=script&lang=js"
export * from "./takeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports